module.exports = __webpack_public_path__ + "img/horizontal_3_4_8004.5958611e.png";